import { autoinject, PLATFORM } from "aurelia-framework";
import { HttpClient } from "aurelia-http-client";
import { Router } from "aurelia-router";
import { StorageService } from "../services/storage";
import { Toast } from "../services/toast";

const STORAGE_KEY: string = 'Auth';
const API_LOGIN: string = "api/admins/login";
const API_AUTH: string = "api/admins/auth";

@autoinject
export class AppUser {
	Id: number = 0;
	Username: string;
	Password: string;
	Role: number;
	Name: string;

	get Token(): string {
		return this._storage.getData(STORAGE_KEY)
	}
	set Token(token: string) {
		this._storage.setData(STORAGE_KEY, token);
	}

	isLoginActive: boolean = false;

	constructor(private _api: HttpClient, private _storage: StorageService, private _router: Router) {
		this._api.configure(x => {
			x.withBaseUrl(PLATFORM.global.$appConfig.apiRoot);
			x.withHeader("Accept", "application/json");
		});
	}

	login() {
		this.isLoginActive = true;

		return this._api.createRequest(API_LOGIN)
			.asPost()
			.withContent({ username: this.Username, password: this.Password })
			.send()
			.then(response => {
				this.isLoginActive = false;

				this.Token = response.content;

				this._router.navigate("/");
			}).catch(e => {
				this.isLoginActive = false;

				try {
					let r = JSON.parse(e.response);
					Toast.error(r.Message || r);
				}
				catch {
					Toast.error("Server connection failed");
				};
			})
			.finally(() => {
				this.Password = undefined;
			});
	}

	logout() {
		this.clear();
		this._router.navigate("/login");
	}

	auth() {
		return this._api.createRequest(API_AUTH)
			.asPost()
			.withHeader(PLATFORM.global.$appConfig.auth, this.Token)
			.send()
			.then(response => {
				let user = JSON.parse(response.response);
				if (user.Status === 0) {
					this.map(user);
				}
				else {
					this.clear();
				}
			}).catch(e => {
				this.clear();
				return e;
			});
	}

	private clear() {
		this.Id = 0;
		this.Role = undefined;
		this.Username = undefined;

		this.Name = undefined;
		this.Password = undefined;
		this.Token = null;
	}

	private map(user: any) {
		this.Id = user.Id;
		this.Role = user.Role;
		this.Username = user.Username;

		this.Name = user.Name;
	}
}
